import { Component } from 'react';
import * as uuid from 'uuid';

export default class HashLevel extends Component {
  constructor(props) {
    super(props);
  }

  addChildren() {
    let children = this.state.children,
      elementId = uuid.v4();

    children.push({
      active: false, // Only used by UI
      id: elementId,
      key: {
        default: '',
        types: ['text'],
        multiple: false,
        mutable: false,
      },
      value: {
        types: ['hash'],
        multiple: false,
        default: '',
        mutable: true,
      },
      required: true,
      description: '',
      label: '',
      children: [],
    });
    this.updateState({ children: children }, () => {
      if (typeof this.onElementClick === 'function') {
        return this.onElementClick(elementId);
      }

      this.props.onElementClick(elementId);
    });
  }

  childClass(index, total) {
    let classNames = [];

    if (index === 0) {
      classNames.push('first');
    }
    if (index === total - 1) {
      classNames.push('last');
    }
    return classNames.join(' ');
  }

  updateState(obj, callback = function () {}) {
    this.props.onChange(
      Object.assign({}, this.state, obj),
      this.props.index,
      callback,
    );
  }

  onElementUpdate(data, index, callback) {
    let children = this.state.children;

    children[index] = data;
    this.updateState({ children: children }, callback);
  }

  getChildrenComponents() {
    return this.state.children.map((i) => {
      // eslint-disable-next-line react/no-string-refs
      return this.refs[i.id];
    });
  }

  inactiveAll() {
    this.setState({ active: false });
    this.getChildrenComponents().map((child) => child.inactiveAll());
  }

  remove(removeIndex) {
    this.updateState({
      children: this.state.children.filter(
        (item, index) => index !== removeIndex,
      ),
    });
  }
}
